// Check if the custom element 'before-after-slider' is not already defined
if (!customElements.get('before-after-slider')) {
  customElements.define('before-after-slider', class BeforeAfterSlider extends HTMLElement {
    constructor() {
      super();

      const slider = this;
      const beforeImages = slider.querySelectorAll('.before-image');
      const resizer = slider.querySelector('.resizer');

      let active = false;

      // Sort overflow out for Overlay Image
      let adjustImageWidth = () => {
        beforeImages.forEach(before => {
          let width = slider.offsetWidth;
          before.style.width = "50%";
        });
      };

      document.addEventListener("DOMContentLoaded", adjustImageWidth);

      resizer.addEventListener('mousedown', function() {
        active = true;
        resizer.classList.add('resize');
      });

      document.body.addEventListener('mouseup', function() {
        active = false;
        resizer.classList.remove('resize');
      });

      document.body.addEventListener('mouseleave', function() {
        active = false;
        resizer.classList.remove('resize');
      });

      document.body.addEventListener('mousemove', function(e) {
        
        if (!active) return;
        
        let x = e.pageX;
        x -= slider.getBoundingClientRect().left;
        slideIt(x);
        pauseEvent(e);
      });

      resizer.addEventListener('touchstart', function() {
        
        active = true;
        resizer.classList.add('resize');
      });

      document.body.addEventListener('touchend', function() {
        
        active = false;
        resizer.classList.remove('resize');
      });

      document.body.addEventListener('touchcancel', function() {
        
        active = false;
        resizer.classList.remove('resize');
      });

      //calculation for dragging on touch devices
      document.body.addEventListener('touchmove', function(e) {
       
        if (!active) return;
        let x;

        let i;
        for (i = 0; i < e.changedTouches.length; i++) {
          x = e.changedTouches[i].pageX;
        }

        x -= slider.getBoundingClientRect().left;
        slideIt(x);
        pauseEvent(e);
      });

      function slideIt(x) {
        let transform = Math.max(0, (Math.min((x / slider.getBoundingClientRect().width) * 100, 100)));
       
        
        beforeImages.forEach(before => {
          before.style.width = transform + "%";
        });
        resizer.style.left = transform - 0 + "%";
      }

      function pauseEvent(e) {
        if (e.stopPropagation) e.stopPropagation();
        if (e.preventDefault) e.preventDefault();
        e.cancelBubble = true;
        e.returnValue = false;
        return false;
      }
    }
  });
}